import EntityGroup from 'library/components/form/entity-radio-group';
import { useState } from 'react';
import {
  Content,
  SearchIcon,
  SearchContainer,
  SearchInput,
} from '../styles';
import withFormContainer from '../hocs/with-form-container';

const Index = ({
  required = false,
  placeholder,
  isMultipleAllowed = true,
  options = [],
  onSearch,
  addButton = null,
  ...restProps
}) => {
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = (e) => {
    const newSearchValue = e.target.value || '';

    setSearchValue(newSearchValue);

    onSearch(newSearchValue);
  };

  return (
    <>
      <SearchContainer>
        <SearchIcon top="33px" className="icon-magnifier" />
        <SearchInput
          placeholder={placeholder}
          value={searchValue}
          onChange={handleSearch}
          onKeyPress={(event) => {
            if (event.code === 'Enter') {
              event.preventDefault();
            }
          }}
        />
      </SearchContainer>
      <Content>
        <EntityGroup
          isMultipleAllowed={isMultipleAllowed}
          required={required}
          options={options}
          {...restProps}
        />
      </Content>
    </>
  );
};

export default withFormContainer(Index);
